import React, { useEffect, useState } from 'react'

import {
  message, Badge, Table, Spin, PageHeader, Divider,
} from 'antd'

import { format } from 'date-fns'

import { fetch } from '../../utils/fetch'

const { Column } = Table

const LogUpdatePo = ({ name }) => {
  const [logUpdatePo, setLogUpdatePo] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(
    () => {
      getDataLogUpdatePo()
    },
    [],
  )

  const getDataLogUpdatePo = (query) => {
    setIsLoading(true)
    fetch({
      url: '/systemLogging/updatePo',
      query,
    }).then((res) => {
      if (res.data?.success) {
        setLogUpdatePo(res.data?.data)
      } else {
        message.error(res.message)
      }
      setIsLoading(false)
    })
  }

  return (
    <>
      <Spin spinning={isLoading} tip="Loading...">
        <PageHeader
          ghost={false}
          title={name}
        >
          <Divider />
          <Table dataSource={logUpdatePo} size="small">
            <Column title="Id" dataIndex="logUpdatePoId" key="logUpdatePoId" width={50} sorter={(a, b) => a.logUpdatePoId - b.logUpdatePoId} sortDirections={['ascend']} />
            <Column title="Po No." dataIndex="poNo" key="poNo" width={100} ellipsis render={(text) => text || '-'} />
            <Column title="XML No." dataIndex="xmlNo" key="xmlNo" width={100} ellipsis render={(text) => text || '-'} />
            <Column title="Status" dataIndex="success" key="success" width={50} align="center" render={(text) => (text ? <Badge status="success" /> : <Badge status="error" />)} />
            <Column title="Message" dataIndex="message" key="message" width={150} ellipsis render={(text) => text || '-'} />
            <Column title="Created At" dataIndex="createdAt" key="createdAt" width={100} render={(text) => format(new Date(text), 'dd/MM/yyyy HH:mm')} />
          </Table>
        </PageHeader>
      </Spin>
    </>

  )
}

export default LogUpdatePo
